<template>
  <div class="billing_box">
    <div class="tasksTop" v-show="account == 0">
      <div class="topSeach">
        <div class="innerSearch">
          <el-input placeholder="Search" v-model="search_invoice" class="input-with-select" id="topInput">
            <el-select v-model="bill_selects" slot="prepend" style="width: 100px">
              <el-option label="Invoice#" value="invoice#"></el-option>
            </el-select>
          </el-input>
        </div>
        <div class="innerSearch">
          <el-select v-model="org_input" placeholder="All">
            <el-option
              v-for="item in org_option"
              :key="item.id"
              :label="item.organization_name"
              :value="item.id">
            </el-option>
            <div slot="prefix">
              Organization:
            </div>
            <div style="clear: both">
            </div>
          </el-select>
        </div>
        <div class="innerSearch cascader">
          <div class="innerTime from">
            <el-date-picker
              v-model="time1"
              type="date"
              :clearable="false"
              placeholder="Select a date"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="chooseDate"
            >
            </el-date-picker>
            <div class="slot">From:</div>
          </div>
        </div>
        <div class="innerSearch cascader">
          <div class="innerTime to">
            <el-date-picker
              v-model="time2"
              type="date"
              :clearable="false"
              placeholder="Select a date"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="chooseDate"
            >
            </el-date-picker>
            <div class="slot">To:</div>
          </div>
        </div>
        <div class="innerSearch cascader">
          <el-select v-model="status_input" placeholder="All">
            <el-option
              v-for="item in status_option"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
            <div slot="prefix">
              Status:
            </div>
            <div style="clear: both">
            </div>
          </el-select>
        </div>
        <div class="innerSearch">
          <el-button type="success" round @click="BillseachHandle" style="width: 80px;padding: 0">Search</el-button>
          <el-button plain @click="BillclearAll" style="width: 80px" class="changeFocus">Clear</el-button>
          <el-button  @click="BillAddNew" style="width: 80px" type="primary">NEW</el-button>
        </div>
      </div>
    </div>
    <div class="top_tabs" v-if="account == 1">
<!--      <el-tabs v-model="billActiveNames"  stretch @tab-click="handleClickTop">-->
<!--        <el-tab-pane label="Bills" name="first">-->
<!--        </el-tab-pane>-->
<!--        <el-tab-pane label="Payment methods" name="second">-->
<!--        </el-tab-pane>-->
<!--      </el-tabs>-->
    </div>

    <div class="tabel" v-loading="billLoading" v-if="billActiveNames == 'first'">
      <el-table v-if="billData.length != 0" :data="billData" style="width: 100%; font-weight: normal">
        <el-table-column header-align="center" align="center" class="invoice_box" prop="invoice" label="invoice#">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="font-weight: normal"
              @click="billDetial(scope.row)"
            >{{ scope.row.invoice }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="legal_company_name" label="Legal Company Name"></el-table-column>
        <el-table-column prop="period" label="Period">
          <template slot-scope="scope">
            <div>{{ scope.row.period }}</div>
            <div class="inner_per_time" :class="scope.row.is_overdue == 1?'yellow':''">{{ scope.row.period_time }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="billing_type" label="Billing Cycle"></el-table-column>
        <el-table-column prop="total" label="Total">
          <template slot-scope="scope">
            <span>${{scope.row.total}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="Status" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 0" class="status_box red">Pending</div>
            <div v-if="scope.row.status == 1" class="status_box yellow_2">Unpaid</div>
            <div v-if="scope.row.status == 2" class="status_box green">Paid</div>
          </template>
        </el-table-column>
        <el-table-column label="Actions" width="130px">
          <template slot-scope="scope">
            <div class="action">
              <span @click="handleApprove(scope.$index, scope.row)" v-if="account == 0">
                <img src="../assets/billing/invoices@2x.png" v-if="scope.row.status == 0" alt=""/>
                <img src="../assets/billing/invoices@2x(1).png" v-else alt=""/>
              </span>
              <span @click="handleRecieve(scope.$index, scope.row)" v-if="account == 0">
                <img src="../assets/billing/receive_payment.png" v-if="scope.row.status == 1" alt=""/>
                <img src="../assets/billing/receive_payment1.png" v-else alt=""/>
              </span>
              <span v-if="account == 1" @click="openManuaAlertHandle(scope.$index,scope.row)">
                <img src="../assets/billing/pay.png" v-if="scope.row.status == 1" alt=""/>
                <img src="../assets/billing/un_pay.png" v-else alt=""/>
              </span>
              <span @click="handleResetPwd(scope.$index, scope.row)">
                <img src="../assets/billing/download@2x(1).png" v-if="scope.row.status != 0" alt=""/>
                <img src="../assets/billing/download@2x.png" v-else alt=""/>
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div v-else class="empty">
        <div>
          <img src="../assets/image/list_blank.png" alt=""/>
          <h2 style="color: #cccccc; font-size: 16px">No items found</h2>
        </div>
      </div>
    </div>
<!--    <div class="second_box" v-if="billActiveNames == 'second'">-->
<!--      <billPayMethod :key="payMethodKey"></billPayMethod>-->
<!--    </div>-->
    <div class="btomPagin"  v-if="billActiveNames == 'first'">
      <div class="innerLeft">
        {{ currentPage }} - <span>{{ billData.length }}</span> of
        <span>{{ pageTotal }}</span> items
      </div>
      <div>
        <el-pagination :page-size="10" layout="prev, pager, next, jumper" :current-page="currentPage" :total="pageTotal"
                       @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
<!--    详情-->
    <el-dialog
      :close-on-click-modal="false"
      custom-class="right"
      title="Detail"
      :visible.sync="billDetialDialog"
      width="33%">
      <billDetial
        :info='bill_detial_info'
        :key="bill_detial_key"
        @openAlert="openAlertHandle"
        @closeDetial="closeBillHandle"
        @approveBillHandle="approveBillHandle"
        @recieveBillHandle="recieveBillHandle"
      ></billDetial>
    </el-dialog>
<!--    approve -->
    <el-dialog
      title="Approve the invoice"
      :visible.sync="approveDialog"
      top="5vh"
      width="32%"
    >
      <div style="margin-top: 24px;margin-bottom: 48px">
        Do you approve the invoice <span>{{ currentBill.invoice }}</span> ? The amount is ${{currentBill.total}}.
      </div>
      <span slot="footer" class="dialog-footer">
         <el-button type="danger" @click="approveDialog = false" plain>No</el-button>
          <el-button type="primary" round @click="approveConfirmHandle">Yes</el-button>
      </span>
    </el-dialog>
<!--    receice the payment-->
    <el-dialog
      title="Receive the payment"
      :visible.sync="recieveDialog"
      top="5vh"
      width="32%"
    >
      <div style="margin-top: 24px;margin-bottom: 48px">
        Have you received payment for the invoice <span>{{ currentBill.invoice }}</span> ? The amount is ${{currentBill.total}}.
      </div>
      <span slot="footer" class="dialog-footer">
         <el-button type="danger" @click="recieveDialog = false" plain>No</el-button>
          <el-button type="primary" round @click="recieveHandle">Yes</el-button>
      </span>
    </el-dialog>
<!--    新增 invoice-->
    <el-dialog
      :close-on-click-modal="false"
      custom-class="noRadio"
      fullscreen
      :visible.sync="createInvoiceDiog"
    >
      <createInvoice @closeCreate="closeCreateHandle"></createInvoice>
    </el-dialog>

    <!--    手动付款 alert -->
    <el-dialog
      title="Payment method Alert"
      :visible.sync="PayAlertDialog"
      top="5vh"
      width="32%"
    >
      <div class="pay_alert">
        Rapidi prefers that our customers pay the amount <span style="color: #E95646">${{bill_detial_info.total}}</span>  via direct deposit (EFT) or E-transfer using the following methods:
        <div style="margin: 24px 0">
          Direct Deposit (EFT):
          <div>{{legal_company_name }}</div>
          <div>Institution No.: {{institution_no}}</div>
          <div> Transit No.: {{transit_no}}</div>
          <div>Account No.: {{account_no}}</div>
          <div style="margin: 24px 0">E-transfer: {{e_transfer_email}}</div>
        </div>
        If you prefer to proceed with online payment, a third-party platform processing fee of <span style="color: #E95646;">${{cost}}</span> will be charged. The total amount is  <span style="color: #E95646">${{sub_total}}</span>.

      </div>
      <span slot="footer" class="dialog-footer">
        <div style="margin-bottom: 16px">
         <el-button type="danger" @click="PayAlertDialog = false" plain>Proceed to external payment</el-button>
        </div>
          <el-button type="primary" round  @click="openManuaHandle" style="padding: 0 26px">Proceed to online payment</el-button>
      </span>
    </el-dialog>
    <!--    客户端 设置手动支付方式-->
    <el-dialog
      title="Manually pay"
      :visible.sync="manuaPayDialog"
      top="5vh"
      width="31%"
      @close="closeManuallyHandle"
    >
      <div style="margin-bottom: 16px">
        <creditPayform ref="manually_form"></creditPayform>
      </div>
      <span slot="footer" class="dialog-footer">
         <el-button type="danger" @click="manuaPayDialog = false" plain>Cancel</el-button>
          <el-button type="primary" round @click="manuallyPayconfirmHandle" >Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import billDetial from "@/components/billDetial";
// import billPayMethod from "@/components/billPayMethod";
import createInvoice from "@/components/createInvoice";
import creditPayform from "@/components/creditPayform";
import {approveBill, getBillList, getRpidiInfo, getStripeCost, payBill, receiveApprove} from "@/api/bill";
import {getOraList} from "@/api/organization";
export default {
  name: "billing",
  components: {
    billDetial,createInvoice,creditPayform
  },
  data() {
    return {
      manuaPayDialog:false,
      account_no:"",
      transit_no:'',
      institution_no:"",
      legal_company_name:"",
      e_transfer_email:"",
      sub_total:'',
      cost:"",
      PayAlertDialog:false,
      payMethodKey:"",//用来刷新billpaymethod
      createInvoiceDiog:false,//新增invoice 弹框
      recieveDialog:false,
      currentBill:'',//当前选中的bill
      approveDialog:false,
      account:'',//当前账号
      billActiveNames:'first',//切换tab
      search_invoice: '',
      limit:10,
      bill_selects: 'invoice#',
      org_input: '',
      org_option: [],
      time1: '',
      time2: "",
      status_input: '',
      status_option: [
        {value:'Pending',key:0},
        {value:'Unpaid',key:1},
        {value:'Paid',key:2},
      ],
      billLoading: false,
      currentPage: 1,
      pageTotal: 10,
      billDetialDialog: false,
      billData: [],
      bill_detial_info: {},
      bill_detial_key:"",//用来控制刷新bill_detial组件
    }
  },
  created() {
    //获取账号权限 dispatch 0管理员 1门店 2派单员 3司机
    this.account = JSON.parse(localStorage.getItem("userInfo")).type;
    // 获取org 列表 getOraList
    getOraList({
      page:1,
      limit:100
    }).then(res=>{
      if (res.code == 200){
        this.org_option = res.data.data
      }
    })
    //获取bill list
    this.getBillListHandle()

  },
  methods: {
    closeCreateHandle(){
      this.createInvoiceDiog = false
      this.getBillListHandle()
    },
    recieveHandle() {
      receiveApprove({
        id:this.currentBill.id
      }).then(res=>{
        if (res.code == 200){
          this.recieveDialog = false
          this.billDetialDialog = false
          this.getBillListHandle()
          this.$message({
            type:'success',
            message:res.msg
          })
        }else {
          this.$message({
            type:'warning',
            message:res.msg
          })
        }
      }).catch(err=>{
        this.$message({
          type:"error",
          message:err.msg
        })
      })
    },
    recieveBillHandle(e){
      this.currentBill = e
      this.recieveDialog = true
    },
    closeBillHandle(){
      this.billDetialDialog = false
      this.getBillListHandle()
    },

    openManuaHandle(){
      this.PayAlertDialog = false
      this.manuaPayDialog = true
    },
    openAlertHandle(){
      getRpidiInfo().then(res=>{
        this.legal_company_name = res.data.legal_company_name
        this.institution_no =res.data.institution_no
        this.transit_no = res.data.transit_no
        this.account_no = res.data.account_no
        this.e_transfer_email = res.data.e_transfer_email
      })
      getStripeCost({
        total:this.bill_detial_info.total
      }).then(res=>{
        this.cost = res.data.cost
        this.sub_total = this.cost + parseInt(this.bill_detial_info.total)
      })

      this.PayAlertDialog = true
    },
    approveBillHandle(e){
      // this.billDetialDialog = false
      this.currentBill = e
      this.approveDialog = true
    },
    approveConfirmHandle(){
      approveBill({
        id:this.currentBill.id
      }).then(res=>{
        if  (res.code == 200){
         this.approveDialog = false
          this.billDetialDialog = false
          this.getBillListHandle()
          this.$message({
            type:'success',
            message:res.msg
          })
        }
      })
    },
    closeManuallyHandle(){
      this.$refs.manually_form.validateClear()
    },
    manuallyPayconfirmHandle(){
      let form = this.$refs.manually_form.credit_form_data
      form.id = this.bill_detial_info.id
      if (this.$refs.manually_form.validateCreditForm()){
        payBill(form).then(res=>{
          if (res.code == 200){
            this.manuaPayDialog = false
            this.closeManuallyHandle()
            this.getBillListHandle()
            this.$message({
              type :"success",
              message:res.data
            })
          }else {
            this.$message({
              type:"error",
              message:res.msg
            })
          }
        }).catch(err=>{
          this.$message({
            type:"error",
            message:err.msg
          })
        })
      }else {

      }

    },
    getBillListHandle(){
      this.billLoading = true
      console.log(this.limit,'getBillListHandle')
      getBillList({
        page:this.currentPage,
        limit:this.limit,
        invoice:this.search_invoice,
        organization_id:this.org_input,
        billing_start_time:this.time1,
        billing_end_time:this.time2,
        status:this.status_input
      }).then(res=>{
        this.billLoading =false

        if (res.code == 200){
          this.billData = res.data.data
          this.pageTotal =  res.data.count
        }else {
          this.$message({
            type:'warning',
            message:res.msg
          })
        }
      }).catch(err=>{
        this.$message({
          type:"error",
          message:err.msg
        })
      })
    },
    BillseachHandle() {
      this.getBillListHandle()
    },
    BillclearAll() {
      this.page = 1
       this.search_invoice =''
      this.org_input =''
      this.time1 = ''
      this.time2 = ''
      this.status_input =''
      this.getBillListHandle()
    },
    //新增 invoice
    BillAddNew(){
      this.createInvoiceDiog = true
    },
    chooseDate() {

    },
    handleCurrentChange() {

    },
    handleApprove(n,v) {
      if (v.status == 0){
        this.currentBill = v
        this.approveDialog = true
      }
    },
    handleRecieve(n,v) {
      if (v.status == 1){
        this.currentBill = v
        this.recieveDialog = true
      }
    },
    openManuaAlertHandle(n,v){
      this.bill_detial_info = v
      this.openAlertHandle()
    },
    handleResetPwd(n,v) {
      if (v.status != 0){
        this.bill_detial_info = v
        this.bill_detial_key = new Date().getTime()
        this.currentBill =v
        this.billDetialDialog = true
      }
    },
    billDetial(detial) {
      console.log(detial)
      this.billDetialDialog = true
      this.bill_detial_key = new Date().getTime()
      this.bill_detial_info = detial
    },
    handleClickTop(){
      this.payMethodKey = new Date().getTime()
    },
  }
}
</script>

<style scoped lang="less">
.billing_box {
  /deep/.el-dialog__body{
    padding-bottom: 0!important;
  }
  .second_box{
    position: relative;
  }
  .top_tabs{
    width: 322px;
    text-align: center;
    margin-bottom: 24px;
    /deep/.el-tabs__nav{
      background-color: #ECECF2!important;
      border-radius: 16px;
    }
    /deep/.el-tabs__header{
      margin: 0;
    }

    /deep/ .el-tabs__nav-scroll{
      padding-left: 0;
    }
    /deep/  .el-tabs__nav-wrap::after{
      background: none ;
    }
    /deep/  .el-tabs__item{
      height: 32px;
      line-height: 32px;
      flex: 1;
      padding-left: 0!important;
      padding-right: 0!important;
    }
    /deep/ .el-tabs__item.is-active{
      background: #E95646;
      color: #FFFFFF;
      border-radius: 16px;
    }
    /deep/.el-tabs__active-bar {
      background: none;
    }
  }

  .tasksTop {
    padding: 8px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 1px solid #E0E0E0;
    display: flex;
    justify-content: space-between;

    /deep/ .changeFocus:focus {
      border: 1px solid #DCDFE6;
      color: #606266;
    }

    .topSeach {
      display: flex;
      flex-wrap: wrap;
      width: 100%;

      /deep/ .el-input--prefix .el-input__inner {
        padding-left: 125px;
      }

      /deep/ .el-input__prefix {
        color: #1F2D42;
      }

      .long_search {
        /deep/ .el-input__inner {
          padding-left: 115px !important;
        }
      }

      .long_searchs {
        /deep/ .el-input__inner {
          padding-left: 133px !important;
        }
      }

      .innerSearch {
        margin: 8px;

        /deep/ .el-cascader {
          line-height: 0;
        }

        .innerTime {
          /deep/ .el-input__prefix {
            position: absolute;
            top: 0;
            right: 12px;
            left: auto;
          }

          /deep/ .el-input--prefix .el-input__inner {
            padding-left: 12px;
          }

          /deep/ .el-input__icon {
            //position: absolute;
            //right: 12px;
            color: #D65953;
          }
        }

        .from {
          /deep/ .el-input__inner {
            padding-left: 75px !important;
          }
        }

        .to {
          /deep/ .el-input__inner {
            padding-left: 55px !important;
          }
        }
      }

      .cascader {
        position: relative;

        /deep/ .el-input__inner {
          padding-left: 80px!important;
        }

        .slot {
          position: absolute;
          padding-left: 24px;
          font-size: 14px;
          top: 5px;
        }
      }

      .ex {
        width: 300px;

        /deep/ .el-input--prefix .el-input__inner {
          padding-left: 110px;
        }
      }
    }

  }

  .tabel {
    margin-top: 16px;

    .action {
      span {
        cursor: pointer;
      }

      img {
        width: 16px;
        margin-right: 16px;
      }
    }

    .invoice_box {
      color: #E95646;
    }

    .inner_per_time {
      font-size: 12px;
      line-height: 14px;
      color: #999999;
    }

    .yellow {
      color: #FFC215;
    }

    .status_box {
      border-radius: 11px;
      width: 103px;
      font-weight: bold;
      font-size: 13px;
      color: #FFFFFF;
      text-align: center;
      margin: 0 auto;
    }

    .red {
      background-color: #E95646;
    }

    .yellow_2 {
      background-color: #FFC215;
    }

    .green {
      background-color: #82D237;
    }
  }
 .pay_alert{
   margin-top: 24px;
   margin-bottom: 48px;
 }
  .empty {
    width: 200px;
    height: 387px;
    margin: 20px auto;
    text-align: center;
    position: relative;

    div {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    h2 {
      font-size: 16px;
    }

    img {
      width: 100%;
      height: 200px;
      margin: 0;
    }
  }

  .btomPagin {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    padding-left: 16px;

    .innerLeft {
      font-size: 16px;
      font-family: SFPro-Regular, SFPro;
      font-weight: 400;
      color: #1f2d42;
      line-height: 20px;
    }
  }

}
</style>
